module.exports = __webpack_public_path__ + "static/img/Screenshot 2021-05-31 183245.4381af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshot 2021-05-31 183245.png
// module id = kNaK
// module chunks = 0